export default __webpack_public_path__ + "static/media/persiapan.35ed8085.png";